import { Formik } from "formik";
import { Button, Box, Switch, FormControlLabel } from "@mui/material";
import CustomField from "../../shared/CustomTextField";
import { useStore } from "../../../hooks/store";
import Styles from "../Form.module.css";
import {
  getAnswer,
  postAnswer,
  updateAnswer,
} from "../../../utils/API/answerMethods";

export default function AnswerForm() {
  const store = useStore();
  const answerData = store.childModal.dataToUpdate;
  const initValues = answerData || {
    question_id: store.form.dataToUpdate.id,
    text: "",
    is_true: 0,
  };

  const questionData = store.form.dataToUpdate;

  const submitAnswer = (values) => {
    postAnswer(values).then(({ data, status }) => {
      if (status === 200) {
        store.setAlert(data, "success");
        getAnswer(questionData.id).then(({ data, status }) => {
          store.setForm(store.form.formChildren, store.form.callBack, {
            ...questionData,
            answers: data,
          });
        });

        store.closeChildModal();

        return;
      }
      store.setAlert(data, "error");
    });
  };

  const submiAnswerUpdated = (values) => {
    updateAnswer(values, values.id).then(({ data, status }) => {
      if (status === 200) {
        store.setAlert(data, "success");
        getAnswer(questionData.id).then(({ data, status }) => {
          store.setForm(store.form.formChildren, store.form.callBack, {
            ...questionData,
            answers: data,
          });
        });
        store.closeChildModal();
        return;
      }
      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = { flexDirection: "row" };

  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        if (answerData) {
          submiAnswerUpdated(values);
        } else {
          submitAnswer(values);
        }

        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        setFieldValue,
        /* and other goodies */
      }) => (
        <>
          <p>{answerData ? "Изменение ответа" : "Создание ответа"}</p>
          <form onSubmit={handleSubmit}>
            <div className={Styles.form_content} style={wrapperStyle}>
              <div className={Styles.form_fields}>
                <CustomField
                  name="text"
                  label="Текст ответ"
                  multiline
                  rows={3}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.text}
                />

                <FormControlLabel
                  control={
                    <Switch
                      name="is_true"
                      checked={values.is_true}
                      onChange={(e) => {
                        const current = Number(e.target.checked);
                        setFieldValue("is_true", current);
                      }}
                    />
                  }
                  label="Верный ответ"
                />
              </div>
            </div>
            <div className="form_actions">
              <Button onClick={handleReset}>Очистить</Button>
              <Button variant="contained" onClick={handleSubmit}>
                Применить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
